import { render } from "./LoadingIcon.vue?vue&type=template&id=64b9a496"
import script from "./LoadingIcon.vue?vue&type=script&lang=js"
export * from "./LoadingIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__